export default __webpack_public_path__ + "static/media/trr-drink-specialty-recharge.1d9c2a8c.png";